// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header {
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  /*margin-top: 30px;*/
  /*margin-bottom: 20px;*/
}

#header.short {
  margin-bottom: 0;
}

#header .logo-container {
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  gap: 12px;
}

#header .back-container {
  padding: 5px;
  cursor: pointer;
}

#header .back-container.hidden {
  display: none;
}

#header .step-container {
  margin-left: 4px;
  padding: 4px 6px;
  font-weight: 700;
  font-size: 17px;
  line-height: 100%;
  letter-spacing: -0.024em;
  justify-content: flex-end;

  border-radius: 16px;
  background-color: var(--white);
}

#header .step-container.hidden {
  display: none;
}

#header .step-container span {
  color: var(--progress-bar-color);
}

#header .progress-bar-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#header .progress-bar-wrapper .progress-bar {
  background-color: var(--progress-bar-background);
  width: 100%;
  border-radius: 20px;
  height: 6px;
}

#header .progress-bar-wrapper .progress-bar.hidden {
  display: none;
}

#header .progress-bar-wrapper .progress-bar .progress {
  height: 6px;
  border-radius: 20px;
  background-color: var(--progress-bar-color);
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.progress-bar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;;EAEzB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,2CAA2C;AAC7C","sourcesContent":["#header {\n  display: flex;\n  flex-direction: column;\n  padding-top: 20px;\n  /*margin-top: 30px;*/\n  /*margin-bottom: 20px;*/\n}\n\n#header.short {\n  margin-bottom: 0;\n}\n\n#header .logo-container {\n  margin-bottom: 18px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n#header .back-container {\n  padding: 5px;\n  cursor: pointer;\n}\n\n#header .back-container.hidden {\n  display: none;\n}\n\n#header .step-container {\n  margin-left: 4px;\n  padding: 4px 6px;\n  font-weight: 700;\n  font-size: 17px;\n  line-height: 100%;\n  letter-spacing: -0.024em;\n  justify-content: flex-end;\n\n  border-radius: 16px;\n  background-color: var(--white);\n}\n\n#header .step-container.hidden {\n  display: none;\n}\n\n#header .step-container span {\n  color: var(--progress-bar-color);\n}\n\n#header .progress-bar-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n#header .progress-bar-wrapper .progress-bar {\n  background-color: var(--progress-bar-background);\n  width: 100%;\n  border-radius: 20px;\n  height: 6px;\n}\n\n#header .progress-bar-wrapper .progress-bar.hidden {\n  display: none;\n}\n\n#header .progress-bar-wrapper .progress-bar .progress {\n  height: 6px;\n  border-radius: 20px;\n  background-color: var(--progress-bar-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
